// Tax rates
export const TAX_RATES = {
  STATE: 0.065,
  COUNTY: 0.0125,
  CITY: 0.02
};

// Tax calculation
export const calculateTax = (subtotal: number): number => {
  const totalTaxRate = TAX_RATES.STATE + TAX_RATES.COUNTY + TAX_RATES.CITY;
  return Math.round((subtotal * totalTaxRate) * 100) / 100;
};
